export default "__VITE_ASSET__DxSnv12J__"